/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { useContext, useState } from 'react';
import { SessionContext } from '../context/SessionContext';
import { sendJoinLaunchEvent } from '../lib/telemetry';

export enum TelemetryState {
  First = 'First',
  SecondAutomatic = 'SecondAutomatic',
  SecondManual = 'SecondManual',
  Ongoing = 'Ongoing',
  Unsupported = 'Unsupported',
  Error = 'Error',
  Success = 'Success',
  DownloadInstructions = 'DownloadInstructions',
}

export enum TelemetryComponent {
  Native = 'Native',
  Web = 'Web',
  Ios = 'Ios',
  Android = 'Android',
}

export enum TelemetryAction {
  Join = 'Join',
  Download = 'Download',
  Retry = 'Retry',
  Fail = 'Fail',
  Install = 'Install',
  Onload = 'Onload',
}

export const useSendTelemetry = () => {
  const {
    telemetryService,
    meetingId,
    meetingInfo,
    sessionTrackingId,
    product,
    flowType,
    theme,
    error,
  } = useContext(SessionContext);
  const [pageFinishedRenderingTimestamp] = useState(Date.now());
  return (
    component: TelemetryComponent,
    action: TelemetryAction,
    state: TelemetryState,
    timeWaitedForUserInput?: number
  ) => {
    sendJoinLaunchEvent(
      telemetryService,
      meetingId,
      sessionTrackingId,
      `trigger${component}${action}`,
      `${product}_${flowType}_${
        state === TelemetryState.Error && error ? error.code : state
      }_${component}_${action}`,
      meetingInfo.build,
      theme.themeType,
      timeWaitedForUserInput ?? Date.now() - pageFinishedRenderingTimestamp
    );
  };
};
